import React from "react";
import {IBasicBreadcrumb} from "../../../interfaces/breadcrumbs/breadcrumbs";



const BasicBreadcrumbs = ({breadCrumbs}:{breadCrumbs: IBasicBreadcrumb[]}) => {
    if (!breadCrumbs.length) return null;

    return (
        <nav id="basic-breadcrumb-container" className="basic-breadcrumb-container" aria-label="Navigate through the nested content">
            <ol className="basic-breadcrumb-list">
                {breadCrumbs.map((crumb: IBasicBreadcrumb, index: number) => {
                    const isLast = index === breadCrumbs.length - 1;

                    return (
                        <li key={index} className="basic-breadcrumb-item">
                            {isLast 
                                ?   (   
                                        <span 
                                            aria-current="page" 
                                            className="basic-breadcrumb-title"
                                        >
                                            {crumb.title}
                                        </span>
                                    )
                                :   (<>
                                        <button
                                            type="button"
                                            className="basic-breadcrumb-button"
                                            onClick={() => {
                                                crumb.onClick?.();
                                                if (crumb.url) {
                                                    window.location.href = crumb.url;
                                                }
                                            }}
                                        >
                                            {crumb.title}
                                        </button>

                                        <span className="basic-breadcrumb-chevron"> › </span>
                                    </>
                                    )
                            }
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
};

export default BasicBreadcrumbs;